/** 현재 지옥 거점 층(허브 기준). 1 = 제1층 거점만 이용, 2부터 장비·각인·상점·도감 해금. */
export const REGISTRY_HELL_FLOOR = 'progress.hellFloor';

export function getHellFloor(registry: Phaser.Data.DataManager): number {
  const v = registry.get(REGISTRY_HELL_FLOOR);
  const n = typeof v === 'number' ? v : Number(v);
  if (!Number.isFinite(n)) return 1;
  return Math.max(1, Math.floor(n));
}
